// import { format } from 'date-fns';
import { matomoEventSend } from './trackMatomo';

/**
 * сбор данных об объекте события для отправки в matomo
 * @param data
 * @returns {{}}
 */
// function parseData(data: object): string {
//   const dataButton = {};
//   if (data) {
//     // eslint-disable-next-line no-return-assign
//     Object.entries(data).forEach(([k, v], index) => dataButton[`${index + 1}`] = { key: k, value: v });
//   }
//   return JSON.stringify(dataButton);
// }

export default class TimeCalculation {
    time: object;

    constructor() {
        this.time = {};
    }

    start(key: string, str: string) {
        if (!this.time?.[key]) {
            this.time[key] = {};
        }
        this.time[key].start = (new Date()).valueOf();
        try {
            this.time[key].str = str.trim().replace(/^\/+|\/+$/g, '');
        } catch (e) {
            this.time[key].str = str;
        }
    }

    stop(key: string, restApiType: string) {
        matomoEventSend({
            category: `Platform ${document.location.pathname}`,
            action: `${document.title} ${restApiType} ${document.location.pathname}`,
            // name_ru: `${format(new Date(), 'yyyy.MM.dd HH:mm:ss.SSS')} ${this.time[key].str}`,
            name_ru: `${this.time[key].str}`,
            // name_en: `${format(new Date(), 'yyyy.MM.dd HH:mm:ss.SSS')} ${this.time[key].str}`,
            name_en: `${this.time[key].str}`,
            // data: JSON.stringify({
            //   '1': ['location', 'testtets']
            // }),
            //   parseData({
            //   api: document.location.pathname
            // }),
            value: (((new Date()).valueOf() - this.time[key].start) / 1000).toFixed(3)
        }, () => { delete this.time[key]; });
    }
}
